import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Job } from 'src/app/public/app/models/job';
import { JobService } from 'src/app/core/services/job.service';
import { ResumeService } from 'src/app/core/services/resume.service';
import { PlanService } from 'src/app/core/services/plan.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AuthService } from 'src/app/core/services/auth.service';

declare var _: any;

@Component({
  selector: 'app-add-candidates-from-job-boards',
  templateUrl: './add-candidates-from-job-boards.component.html',
  styleUrls: ['./add-candidates-from-job-boards.component.css']
})
export class AddCandidatesFromJobBoardsComponent implements OnInit {

  @Input() jobId: any;
  @Output() saveCallback = new EventEmitter<void>();

  job: any = {};
  jobBoardDetails: any[] = [];
  jobBoardDetailsCopy: any[] = [];
  requisitionDetails: any = {};
  resumePullCounts = [5, 10, 15, 20, 25];
  jobBoardsResumePullLeft = 0;
  jobBoardsPullResumePulled = 0;
  activeJobBoardsFilterTabNumber = 0;

  isJobBoardSelected = false;
  isGetCandidateFetchCalled = false;
  isParametersEditable = true;
  isLoading = true;
  isTrialPlanActive = false;
  isCorporate = false;

  companyId: any;
  radiusOptions: any;
  recencyOptions: any;
  jobBoardParameters: any;

  constructor(
    private sanitizer: DomSanitizer,
    private jobService: JobService,
    private resumeService: ResumeService,
    private planService: PlanService,
    private companyService: CompanyService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private authService:AuthService
  ) { }

  ngOnInit() {
    this.companyId = this.authService.getUserDetails().company.companyId;
    this.isCorporate = this.companyService.isCorporateCompany();
    this.getPlanDetails(() => {
      if (this.isTrialPlanActive) {
        this.getJobBoardsResumePullLimits();
      }
    });
    this.getJob(() => {
      this.getAllJobBoards(() => {
        this._setJobBoardDetails();
        this.getJobBoardParameters();
      });
      this.getRequisitionDetails();
      this.getRadiusAndRecencyOptions();
    });
  }

  getPlanDetails(successCallback) {
    this.planService.getCompanyPlanDetails(this.companyId, (data) => {
      if (!_.isNull(data.features) && data.features.length) {
        this.isTrialPlanActive = data.plan === 'Trial';
        successCallback();
      }
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getJobBoardsResumePullLimits() {
    this.planService.getAvailableJobBoardsPullCount(this.companyId, (data) => {
      this.jobBoardsResumePullLeft = data.jobBoardResumesLeftCount;
      this.jobBoardsPullResumePulled = data.jobBoardResumesPulledCount;
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getJobBoardParameters() {
    this.jobService.getJobBoardParameters((data) => {
      this.jobBoardParameters = data;
      this.parseJobBoardParameters();
      this.isLoading = false;
    }, (error) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  parseJobBoardParameters() {
    (this.job.jobBoardDetails || []).forEach((val) => {
      const flags = [];
      const jobBoardsParams = !_.isNull(val.daxtraCode) ? this.jobBoardParameters.jobBoardParameterMap[val.daxtraCode] : null;

      flags.push(!_.isNull(val.daxtraCode));
      flags.push(this._isParameterSupported(jobBoardsParams, 'postcode'));
      flags.push(this._isParameterSupported(jobBoardsParams, 'radius'));
      flags.push(this._isParameterSupported(jobBoardsParams, 'jobType'));
      flags.push(this._isParameterSupported(jobBoardsParams, 'recency'));
      flags.push(this._isParameterSupported(jobBoardsParams, 'education'));
      flags.push(this._isParameterSupported(jobBoardsParams, 'industry'));
      flags.push(this._isParameterSupported(jobBoardsParams, 'salary'));
      val.flags = flags;
    });
    this.jobBoardDetailsCopy = _.cloneDeep(this.job.jobBoardDetails);
  }

  private _isParameterSupported(jobBoardParameters, parameter) {
    return !!jobBoardParameters && jobBoardParameters.indexOf(parameter) !== -1;
  }

  getJob(successCallback) {
    this.jobService.getJob(this.jobId, (data) => {
      this.job = this._parseJobResponse(data);
      successCallback(data);
    }, (error) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  private _parseJobResponse(data) {
    const tempJob: any = new Job();
    tempJob.id = data.id;
    tempJob.title = data.title;
    if (_.isNull(data.clientorbu)) {
      tempJob.clientorbu = null;
    } else {
      tempJob.clientorbu = {
        name: data.clientorbu.name,
        id: data.clientorbu.id,
        shortName: data.clientorbu.shortName
      };
    }
    tempJob.jobType = data.jobType;
    tempJob.location = data.location;
    tempJob.locationLabel = '-';
    if (!_.isNull(tempJob.location)) {
      if (!_.isNull(data.location.city)) {
        tempJob.locationLabel = data.location.city;
      }
      if (_.isNull(tempJob.locationLabel) || tempJob.locationLabel === '-') {
        tempJob.locationLabel = data.location.state;
        if (_.isNull(tempJob.locationLabel)) {
          tempJob.locationLabel = '-';
        }
      } else {
        if (!_.isNull(data.location.state)) {
          tempJob.locationLabel += ', ' + data.location.state;
        }
      }
      if (_.isNull(tempJob.locationLabel) || tempJob.locationLabel === '-') {
        tempJob.locationLabel = data.location.zipcode;
        if (_.isNull(tempJob.locationLabel)) {
          tempJob.zipcode = '-';
        }
      } else {
        if (!_.isNull(data.location.zipcode)) {
          tempJob.locationLabel += ', ' + data.location.zipcode;
        }
      }
    }
    tempJob.educationList = data.educationList;
    tempJob.licensePreferences = data.licensePreferences;
    tempJob.radius = data.radius;
    tempJob.recency = data.recency;
    tempJob.salary = data.salary;
    tempJob.industry = data.industry;
    tempJob.jobBoardDetails = _.cloneDeep(this.jobBoardDetails);
    if (!_.isNull(tempJob.licensePreferences) && !_.isNull(tempJob.licensePreferences.jobBoardDetails)) {
      tempJob.jobBoardDetails.forEach((val) => {
        if (_.findIndex(tempJob.licensePreferences.jobBoardDetails, { boardId: val.boardId, enabled: true }) === -1) {
          val.enabled = false;
        }
      });
      tempJob.resumesToPullPerJobBoardCount = tempJob.licensePreferences.resumesToPullPerJobBoardCount;
    }
    tempJob.daxtraParameters = data.daxtraParameters;
    if (!(_.isNull(data.daxtraParameters) || _.isUndefined(data.daxtraParameters)) && !(_.isNull(data.advancedParametersImage) || _.isUndefined(data.advancedParametersImage))) {
      this.activeJobBoardsFilterTabNumber = 1;
    }
    tempJob.advancedParametersImage = this.sanitizer.bypassSecurityTrustResourceUrl(data.advancedParametersImage);
    return tempJob;
  }

  getAllJobBoards(successCallback) {
    let buId = null;
    if (!_.isNull(this.job.clientorbu) && this.isCorporate) {
      buId = this.job.clientorbu.id;
    }
    this.resumeService.getResumeSourceTypes(this.companyId, buId, (data) => {
      if (data.length > 0) {
        data.forEach((val) => {
          val.boardId = val.id;
          val.enabled = true;
          delete val.id;
        });
        this.jobBoardDetails = data;
      }
      if (successCallback) {
        successCallback();
      }
    }, (error) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  private _setJobBoardDetails() {
    this.job.jobBoardDetails = _.cloneDeep(this.jobBoardDetails);
    if (!_.isNull(this.job.licensePreferences) && !_.isNull(this.job.licensePreferences.jobBoardDetails)) {
      this.job.jobBoardDetails.forEach((val) => {
        if (_.findIndex(this.job.licensePreferences.jobBoardDetails, { boardId: val.boardId, enabled: true }) === -1) {
          val.enabled = false;
        }
      });
    }
    this.job.jobBoardDetails.forEach((val) => {
      if (val.enabled === true) {
        this.isJobBoardSelected = true;
      }
    });
  }

  getRadiusAndRecencyOptions() {
    this.jobService.getRadiusAndRecencyOptions((data) => {
      this.radiusOptions = data.radius;
      this.recencyOptions = data.recency;

      if (_.isNull(this.job.radius)) {
        this.job.radius = data.defaultRadius[0];
      }

      if (_.isNull(this.job.recency)) {
        this.job.recency = data.defaultRecency[0];
      }
    }, (error) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  checkStatusAndGetResumesFromJobBoards() {
    this.isGetCandidateFetchCalled = true;
    this.jobService.getGetMoreResumesJobStatus(this.job.id, (jobInProgress) => {
      if (jobInProgress === true) {
        this.isGetCandidateFetchCalled = false;
        this.alertsAndNotificationsService.showBannerMessage("Candidates Fetch from Job Boards already <b>'INPROGRESS'</b>. Please try after sometime.", 'info');
      } else {
        this.getResumesFromJobBoards();
      }
    }, (error) => {
      this.isGetCandidateFetchCalled = false;
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getResumesFromJobBoards() {
    this.jobService.getResumesFromJobBoards(this.job.id, this.job.jobBoardDetails, this.job.resumesToPullPerJobBoardCount, this.job.radius, this.job.recency, () => {
      this.isGetCandidateFetchCalled = false;
      this.saveCallback.emit();
      this.alertsAndNotificationsService.showAlert('Success!', 'Candidates are being fetched from Job Boards. You will be notified once the candidates are fetched', 'success');
    }, (error) => {
      this.isGetCandidateFetchCalled = false;
      this.alertsAndNotificationsService.showAlert('Fail!', error.message, 'warning');
    });
  }

  getRequisitionDetails() {
    this.jobService.getRequisitionDetails(this.job.id, this.companyId, (data) => {
      this.requisitionDetails = data;
    }, (error) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  onJobBoardSelectionChange() {
    this.isJobBoardSelected = false;
    (this.job.jobBoardDetails || []).forEach((val) => {
      if (val.enabled === true) {
        this.isJobBoardSelected = true;
      }
    });
  }

  cancel() {
    this.saveCallback.emit();
  }
}
